import { render, staticRenderFns } from "./CheckoutOld.vue?vue&type=template&id=19671abe"
import script from "./CheckoutOld.vue?vue&type=script&lang=js"
export * from "./CheckoutOld.vue?vue&type=script&lang=js"
import style0 from "./CheckoutOld.vue?vue&type=style&index=0&id=19671abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports